import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import SipDialog from '../dialogs/SipDialog';

const SipsEditor = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { action1, actionId1 } = useParams();

  const [navigationDepth, setNavigationDepth] = useState(0);
  const [pathname, setPathname] = useState('');

  // navigation effect
  useEffect(() => {
    if (pathname === '') {
      // first call
    } else if (pathname.includes(location.pathname)) {
      setNavigationDepth((depth) => Math.max(0, depth - 1));
    } else {
      setNavigationDepth((depth) => depth + 1);
    }
    setPathname(location.pathname);
  }, [location]);

  const handleClose = () => {
    if (navigationDepth) {
      navigate(-1);
    } else if (actionId1) {
      navigate('../../', { replace: true });
    } else {
      navigate('../', { replace: true });
    }
  };

  return (
    <>
      <SipDialog
        handleClose={() => handleClose()}
      />
    </>
  );
};

export default SipsEditor;
